

















import { Component, Prop, Vue } from 'vue-property-decorator'
import TrelloClient, { TrelloMember } from '@/TrelloClient'
import { TrelloConfig } from '@/config'

@Component
export default class extends Vue {

    selectedMemberId = ''

    fetching = true

    get options(): object[] {
        return this.members.map(this.trelloMemberToSelectOption)
    }

    members: TrelloMember[] = [];

    trelloMemberToSelectOption(member: TrelloMember): object {
        return {
            value: member.id,
            text: member.fullName,
        }
    }

    populateMembers() {
        this.fetching = true
        this.$store.state.trello.fetchBoardMembers(TrelloConfig.mainBoardId).then((members: TrelloMember[]) => {
            console.log('Preso lista dei membri da Trello')
            this.members = members
            this.fetching = false
        })
    }

    onMemberSelected(memberId: any) {
        console.log('Scelto un membro dalla select')
        this.$emit('memberSelected', memberId)
        this.$store.commit('updateActiveMemberId', memberId)
    }

    mounted() {
        // Inizializza il client di Trello
        let trelloClient = new TrelloClient()
        // Autentica l'utente
        trelloClient.init(TrelloConfig.appKey).then(() => {
            // Memorizza il client di Trello nello store così
            // che possano usarlo anche le altre componenti
            this.$store.commit('updateTrelloClient', trelloClient)
            // Prenditi l'ID dell'utente autenticato
            this.$store.dispatch('fetchAuthorizedMember').then((authorizedMember) => {
                // Seleziona il membro autorizzato nella select
                this.selectedMemberId = authorizedMember.id
                this.onMemberSelected(authorizedMember.id)
                // Popola le opzioni della select con i membri di Trello
                this.populateMembers()
            })
        })
    }
}
